import React, { useContext, useEffect, useState } from "react";
import usePayout from "../../../services/Order/usePayout";
import usePayments from "../../../services/Order/usePayments";
import useWhatsappNumbers from "../../../services/Whatsapp/useWhatsappNumbers";
import useCampaigns from "../../../services/Whatsapp/useCampaigns";
import * as XLSX from "xlsx";

import {
  CreditCard,
  Wallet,
  QrCode,
  BadgeIndianRupee,
  XCircle,
  Layers,
  Truck,
  Megaphone,
  RotateCcw,
  Eye,
} from "lucide-react";

import OrdersTable from "./OrderTable";
import ProcessedSettlementsTable from "./ProcessSettlement";
import AssignToPackky from "./AssignToPackky";
import CampaigningCharges from "./CampaigningCharges";
// import RefundTable from "./RefundTable";
import { toast, ToastContainer } from "react-toastify";
import WalletTransactionModal from "./walletTransactionModel";
import PaginationComponent from "../../../utils/TablePagination";
import OrderDetailsModal from "../orders/OrderDetailsModel";
import useOrders from "../../../services/Order/useOrder";
import { GlobalContext } from "../../../Context/GlobalContext";

export const Payments = () => {
  const { wallet, getWalletBalance } = usePayout();
  const {
    analytics,
    getAnalytics,
    getSettlementCharges,
    settlementCharges,
    getRefunds,
    refunds,
    getOrderTypeCount,
    orderTypeCount,
    getSettlementInvoices,
    settlementInvoices,
    walletTransactions,
    getWalletTransactionDetails,

    transactionsReport,
    transactionsReportLoading,
    getTransactionsReport,
  } = usePayments();

  const { userID } = useContext(GlobalContext);
  const { whatsappNumbers, fetchWhatsappNumbers } = useWhatsappNumbers();

  const { campaigns, getCampaigns } = useCampaigns();
  const { getOrderDetails } = useOrders();
  const [orderDetailsLoading, setOrderDetailsLoading] = useState(false);

  const [startDate, setStartDate] = useState(""); // input
  const [endDate, setEndDate] = useState("");

  const [appliedStartDate, setAppliedStartDate] = useState(""); // API
  const [appliedEndDate, setAppliedEndDate] = useState("");
  const [walletFromDate, setWalletFromDate] = useState("");
  const [walletToDate, setWalletToDate] = useState("");
  const [activeTab, setActiveTab] = useState("upi");
  const walletBalance = parseFloat(wallet?.wallet_bal || 0);
  const unsettledAmount = parseFloat(wallet?.unsettled_Amount || 0);
  const [loading, setLoading] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const getPaymentModeByTab = (tab) => {
    const modeMap = {
      upi: "UPI",
      cash: "CASH",
      qr: "QR",
      credit: "CREDIT",
      failed: "",
    };

    return modeMap[tab] ?? "";
  };

  const fetchTransactionsReportByTab = async (tab, fromDate, toDate) => {
    if (!userID || !fromDate || !toDate) {
      return;
    }

    const paymentMode = getPaymentModeByTab(tab);

    const payload = {
      userId: String(userID),
      fromDate,
      toDate,
      paymentMode,
    };

    console.log("TRANSACTIONS REPORT PAYLOAD:", payload);

    const res = await getTransactionsReport(payload);

    console.log("TRANSACTIONS REPORT RESPONSE:", res);

    if (res?.responseCode !== "00") {
      toast.error(
        res?.responseMessage || "Failed to fetch transactions report",
      );
    }
  };

  const handleFetch = () => {
    getWalletTransactionDetails(startDate, endDate);
  };

  const handleApply = () => {
    if (!startDate || !endDate) {
      toast.error("Please select both dates");
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      toast.error("From date cannot be greater than to date");
      return;
    }

    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
  };

  const handleOrderClick = async (order) => {
    try {
      setOrderDetailsLoading(true);

      const orderId =
        order?.orderid || order?.refrence?.split("/")?.[0]?.trim();

      if (!orderId) {
        toast.error("Order ID not found");
        return;
      }

      const details = await getOrderDetails(orderId);

      if (details) {
        setSelectedOrder(details);
      } else {
        toast.error("Order details not found");
      }
    } catch (error) {
      console.error("Order details error:", error);
      toast.error("Failed to fetch order details");
    } finally {
      setOrderDetailsLoading(false);
    }
  };

  const handleOpenWallet = () => {
    const today = new Date().toISOString().slice(0, 10);

    setWalletFromDate(today);
    setWalletToDate(today);

    setShowWalletModal(true);

    getWalletTransactionDetails(today, today);
  };

  const handleWalletFetch = () => {
    if (!walletFromDate || !walletToDate) return;

    getWalletTransactionDetails(walletFromDate, walletToDate);
  };

  const topCards = [
    {
      leftLabel: "Total Order Amount",
      leftKey: "totalOrderAmount",
      rightLabel: "Settlement Amount",
      rightKey: "totalSettlementAmount",
    },
    {
      leftLabel: "Platform Charges",
      leftKey: "totalPlatformCharges",
      rightLabel: "Delivery Charges",
      rightKey: "totalDeliveryCharges",
    },
  ];

  const labelMap = {
    orderAmount: "Order Amount",
    messageCharges: "Message Charges",
    messageChargesHomeDeliveries: "Message Charges Home",
    totalMessageChargesDeduction: "Total Message Charges",
    platformCharges: "Platform Charges",
    deliveryCharges: "Delivery Charges",
    settlementAmount: "Settlement Amount",
  };

  const filteredData = (type) => {
    const list = Array.isArray(transactionsReport) ? transactionsReport : [];

    if (type === "failed") {
      return list.filter(
        (item) =>
          String(item.category || "").toLowerCase() === "incomplete_order",
      );
    }

    return list.filter(
      (item) =>
        String(item.category || "").toLowerCase() !== "incomplete_order",
    );
  };

  const allData = filteredData(activeTab);

  const formatDownloadData = (data) => {
    return data.map((item, index) => ({
      "S.No": index + 1,
      "Order ID": item.orderid || item.refrence,
      "Customer Name": item.customer_name || "NA",
      Mobile: item.customer_mobile || "",
      "Order Type": item.order_type,
      "Payment Mode": item.payment_mode,
      Amount: item.credit,
      Deduction: item.totalDeduction,
      Settlement: item.settlement_amount,
      Status: item.settlement_status === "Y" ? "Settled" : "Unsettled",
      Date: item.datetime,
    }));
  };

  const handleDownloadExcel = (data) => {
    if (!data || data.length === 0) {
      toast.warning("No data available to download");
      return;
    }

    const formattedData = formatDownloadData(data);

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

    XLSX.writeFile(workbook, "Transactions_Report.xlsx");

    toast.success("Excel downloaded successfully");
  };

  const handleRefresh = async () => {
    const start = appliedStartDate || startDate;
    const end = appliedEndDate || endDate;

    if (!start || !end) {
      toast.error("Please select dates first");
      return;
    }

    if (new Date(start) > new Date(end)) {
      toast.error("From date cannot be greater than to date");
      return;
    }

    try {
      setLoading(true);

      if (["upi", "cash", "qr", "credit", "failed"].includes(activeTab)) {
        await fetchTransactionsReportByTab(activeTab, start, end);
      }

      if (activeTab === "settlements") {
        await getSettlementInvoices(start, end);
      }

      if (activeTab === "campaign") {
        await getCampaigns();
        await fetchWhatsappNumbers();
      }
    } catch (error) {
      console.error("Refresh error:", error);
      toast.error("Failed to refresh data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userID || !appliedStartDate || !appliedEndDate) return;

    if (["upi", "cash", "qr", "credit", "failed"].includes(activeTab)) {
      fetchTransactionsReportByTab(activeTab, appliedStartDate, appliedEndDate);
    }
  }, [activeTab, appliedStartDate, appliedEndDate, userID]);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);

    setStartDate(today);
    setEndDate(today);

    setAppliedStartDate(today);
    setAppliedEndDate(today);

    getWalletBalance();
  }, []);

  useEffect(() => {
    if (!appliedStartDate || !appliedEndDate) return;

    getAnalytics(appliedStartDate, appliedEndDate);
  }, [appliedStartDate, appliedEndDate]);

  useEffect(() => {
    if (!appliedStartDate || !appliedEndDate) return;

    getSettlementCharges(appliedStartDate, appliedEndDate);
  }, [appliedStartDate, appliedEndDate]);

  useEffect(() => {
    if (!appliedStartDate || !appliedEndDate) return;

    getOrderTypeCount(appliedStartDate, appliedEndDate);
  }, [appliedStartDate, appliedEndDate]);

  useEffect(() => {
    if (!appliedStartDate || !appliedEndDate) return;

    const fetchOtherTabData = async () => {
      try {
        setLoading(true);

        if (activeTab === "settlements") {
          await getSettlementInvoices(appliedStartDate, appliedEndDate);
        }

        if (activeTab === "campaign") {
          await getCampaigns();
          await fetchWhatsappNumbers();
        }
      } catch (error) {
        console.error("Tab data error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOtherTabData();
  }, [activeTab, appliedStartDate, appliedEndDate]);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, appliedStartDate, appliedEndDate]);

  // const allData = filteredData(activeTab);
  const itemsPerPage = 50;
  // Reset safety (avoid 0 pages issue)
  const totalPages = Math.max(1, Math.ceil(allData.length / itemsPerPage));

  // Slice data for current page

  const paginatedData = allData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <>
      <ToastContainer />

      <div className="px-4 h-full overflow-y-auto montserrat-font-1">
        {/* HEADER */}
        <div className="sticky top-0 z-40 bg-[#f8fafc] pb-4">
          <div className="flex flex-wrap justify-between items-center montserrat-font-1">
            <h1 className="text-xl mt-8 font-semibold">Payment Report</h1>

            <div className="flex items-center gap-2 flex-wrap">
              {/* Wallet */}
              <div
                onClick={handleOpenWallet}
                className="bg-white px-3 py-1 rounded shadow text-sm flex cursor-pointer items-center gap-2 hover:bg-gray-50 transition"
              >
                <span>Wallet Balance :</span>

                <span
                  className={`font-semibold ${
                    walletBalance < 0 ? "text-red-600" : "text-green-600"
                  }`}
                >
                  ₹ {walletBalance.toFixed(2)}
                </span>

                <Eye
                  title="View Transactions"
                  className="w-4 h-4 text-gray-600 hover:text-black"
                />
              </div>

              {/* Unsettled */}
              <div className="bg-white px-3 py-1 rounded shadow text-sm">
                Unsettled Amount :
                <span className="ml-2 text-green-600 font-semibold">
                  ₹ {unsettledAmount.toFixed(2)}
                </span>
              </div>

              {/* Dates */}
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="border px-2 py-1 rounded"
              />

              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="border px-2 py-1 rounded"
              />

              <button
                onClick={handleApply}
                className="bg-green-600 text-white px-4 py-1.5 rounded-lg"
              >
                Apply
              </button>

              <button
                onClick={() => handleDownloadExcel(filteredData(activeTab))}
                className="bg-blue-600 text-white px-4 py-1.5 rounded-lg"
              >
                Download
              </button>

              <button
                onClick={handleRefresh}
                className="border border-gray-300 px-3 py-1.5 flex items-center gap-1 rounded-lg bg-green-600 text-white"
              >
                <RotateCcw className="w-4 h-4" />
                Refresh
              </button>
            </div>
          </div>
        </div>

        <div className="flex-1 min-h-0 flex flex-col">
          <div>
            {/* TOP CARDS */}

            <div className="grid md:grid-cols-4 gap-4 mb-4 montserrat-font-1">
              {/* First 2 Cards */}
              {topCards.map((card, i) => {
                const leftVal = parseFloat(analytics?.[card.leftKey] || 0);
                const rightVal = parseFloat(analytics?.[card.rightKey] || 0);

                return (
                  <div
                    key={i}
                    className="bg-white rounded-xl shadow p-4 flex justify-between"
                  >
                    {/* LEFT */}
                    <div>
                      <p className="text-sm text-gray-500">{card.leftLabel}</p>
                      <p className="font-bold text-blue-600">
                        ₹ {leftVal.toFixed(2)}
                      </p>
                    </div>

                    <div className="border-l mx-3"></div>

                    {/* RIGHT */}
                    <div>
                      <p className="text-sm text-gray-500">{card.rightLabel}</p>
                      <p
                        className={`font-bold ${
                          rightVal < 0 ? "text-red-600" : "text-green-600"
                        }`}
                      >
                        ₹ {rightVal.toFixed(2)}
                      </p>
                    </div>
                  </div>
                );
              })}

              {/* QR Total Card */}
              <div className="bg-green-50 border border-green-200 rounded-xl shadow-sm p-4 flex items-center justify-between">
                <div>
                  <p className="text-sm text-green-700 font-medium">QR Total</p>
                  <p className="text-2xl font-bold text-green-700 mt-1">
                    ₹ {parseFloat(analytics?.qr_total || 0).toFixed(2)}
                  </p>
                  <p className="text-xs text-green-600 mt-1">
                    Total QR payment amount
                  </p>
                </div>

                <div className="w-11 h-11 rounded-xl bg-green-100 flex items-center justify-center">
                  <QrCode size={22} className="text-green-700" />
                </div>
              </div>

              {/* Messages Card */}
              <div className="bg-white rounded-xl shadow p-4 grid grid-cols-3 text-center montserrat-font-1">
                <div>
                  <p className="text-xs text-gray-500">Total Messages</p>
                  <p className="text-green-600 font-bold">
                    {analytics?.totalMessages || 0}
                  </p>
                </div>

                <div>
                  <p className="text-xs text-gray-500">Per Msg Cost</p>
                  <p className="text-blue-600 font-bold">
                    ₹ {parseFloat(analytics?.perMessageCost || 0).toFixed(2)}
                  </p>
                </div>

                <div>
                  <p className="text-xs text-gray-500">Msg Charges</p>
                  <p className="text-blue-600 font-bold">
                    ₹{" "}
                    {parseFloat(analytics?.totalMessageCharges || 0).toFixed(2)}
                  </p>
                </div>
              </div>
            </div>

            {/* MINI CARDS */}
            <div className="flex flex-wrap gap-3 mb-4 montserrat-font-1">
              {(settlementCharges || []).map((item, i) => {
                const amount = parseFloat(item.value || 0);

                const typeMap = {
                  0: "net",
                  1: "credit",
                  2: "debit",
                };

                const type = typeMap[item.type];

                const styles = {
                  net: {
                    bg: "bg-blue-50",
                    border: "border-blue-200",
                    iconBg: "bg-blue-100",
                    iconText: "text-blue-800",
                    tag: "bg-blue-100 text-blue-700",
                  },
                  credit: {
                    bg: "bg-green-50",
                    border: "border-green-200",
                    iconBg: "bg-green-100",
                    iconText: "text-green-800",
                    tag: "bg-green-100 text-green-700",
                  },
                  debit: {
                    bg: "bg-red-50",
                    border: "border-red-200",
                    iconBg: "bg-red-100",
                    iconText: "text-red-800",
                    tag: "bg-red-100 text-red-700",
                  },
                };

                const style = styles[type];

                return (
                  <div
                    key={i}
                    className={`flex items-center justify-between gap-3 px-3 py-2 min-h-[58px] rounded-xl border ${style.bg} ${style.border} w-[210px]`}
                  >
                    {/* LEFT */}
                    <div className="flex items-center montserrat-font-1 gap-2">
                      <div
                        className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-semibold ${style.iconBg} ${style.iconText}`}
                      >
                        ₹
                      </div>

                      <div>
                        <p className="text-xs text-gray-500">
                          {labelMap[item.label] || item.label}
                        </p>

                        <p
                          className={`text-sm font-semibold ${
                            amount < 0 ? "text-red-600" : "text-gray-800"
                          }`}
                        >
                          ₹ {Math.abs(amount).toFixed(2)}
                        </p>
                      </div>
                    </div>

                    {/* TAG */}
                    <span
                      className={`text-[10px] px-2 py-[2px] rounded-full font-medium ${style.tag}`}
                    >
                      {type === "net"
                        ? "Net"
                        : type === "credit"
                          ? "Credit"
                          : "Debit"}
                    </span>
                  </div>
                );
              })}
            </div>

            {/*  MIDDLE SECTION */}

            {orderTypeCount?.length > 0 && (
              <div className="bg-white px-4 py-2 rounded-lg shadow mb-3 montserrat-font-1">
                {(orderTypeCount || []).map((item, i) => (
                  <div
                    key={i}
                    className="flex justify-between items-center py-2 border-b last:border-none"
                  >
                    <div className="font-medium text-gray-700">
                      {item.clientName}
                    </div>

                    <div className="flex gap-2 flex-wrap">
                      {(item.orderTypes || []).map((type, j) => {
                        const count = Number(type.orderCount || 0);

                        let label = type.orderType;
                        let color = "bg-gray-500";

                        if (type.orderType === "home_delivery") {
                          label = "Home Delivery";
                          color = "bg-blue-600";
                        } else if (type.orderType === "takeaway") {
                          label = "Takeaway";
                          color = "bg-green-600";
                        }

                        return (
                          <span
                            key={j}
                            className={`px-3 py-1 rounded-full text-xs text-white ${color}`}
                          >
                            {label} {count}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* 🔹 TABS */}

          <div className="sticky top-[52px] z-20 bg-[#f8fafc] border-b montserrat-font-1">
            <div className="flex gap-6 mt-5 text-sm font-medium overflow-x-auto">
              <button
                onClick={() => setActiveTab("upi")}
                className={`pb-2 flex items-center gap-2 border-b-2 transition ${
                  activeTab === "upi"
                    ? "border-green-600 text-green-600"
                    : "border-transparent text-gray-500 hover:text-green-600"
                }`}
              >
                <CreditCard size={16} />
                UPI Orders
              </button>

              <button
                onClick={() => setActiveTab("cash")}
                className={`pb-2 flex items-center gap-2 border-b-2 transition ${
                  activeTab === "cash"
                    ? "border-green-600 text-green-600"
                    : "border-transparent text-gray-500 hover:text-green-600"
                }`}
              >
                <Wallet size={16} />
                Cash Orders
              </button>

              <button
                onClick={() => setActiveTab("qr")}
                className={`pb-2 flex items-center gap-2 border-b-2 transition ${
                  activeTab === "qr"
                    ? "border-green-600 text-green-600"
                    : "border-transparent text-gray-500 hover:text-green-600"
                }`}
              >
                <QrCode size={16} />
                QR Orders
              </button>

              <button
                onClick={() => setActiveTab("credit")}
                className={`pb-2 flex items-center gap-2 border-b-2 transition ${
                  activeTab === "credit"
                    ? "border-green-600 text-green-600"
                    : "border-transparent text-gray-500 hover:text-green-600"
                }`}
              >
                <BadgeIndianRupee size={16} />
                Credit Orders
              </button>

              {/* <button
            onClick={() => setActiveTab("failed")}
            className={`pb-2 flex items-center gap-2 border-b-2 transition ${
              activeTab === "failed"
                ? "border-green-600 text-green-600"
                : "border-transparent text-gray-500 hover:text-green-600"
            }`}
          >
            <XCircle size={16} />
            Un-Successfull Orders
          </button> */}

              <button
                onClick={() => setActiveTab("settlements")}
                className={`pb-2 flex items-center gap-2 border-b-2 transition ${
                  activeTab === "settlements"
                    ? "border-green-600 text-green-600"
                    : "border-transparent text-gray-500 hover:text-green-600"
                }`}
              >
                <Layers size={16} />
                Processed Settlements
              </button>

              <button
                onClick={() => setActiveTab("packky")}
                className={`pb-2 flex items-center gap-2 border-b-2 transition ${
                  activeTab === "packky"
                    ? "border-green-600 text-green-600"
                    : "border-transparent text-gray-500 hover:text-green-600"
                }`}
              >
                <Truck size={16} />
                Assign To Packky
              </button>

              <button
                onClick={() => setActiveTab("campaign")}
                className={`pb-2 flex items-center gap-2 border-b-2 transition ${
                  activeTab === "campaign"
                    ? "border-green-600 text-green-600"
                    : "border-transparent text-gray-500 hover:text-green-600"
                }`}
              >
                <Megaphone size={16} />
                Campaigning Charge
              </button>

              {/* <button
            onClick={() => setActiveTab("refund")}
            className={`pb-2 flex items-center gap-2 border-b-2 transition ${
              activeTab === "refund"
                ? "border-green-600 text-green-600"
                : "border-transparent text-gray-500 hover:text-green-600"
            }`}
          >
            <RotateCcw size={16} />
            Refunds
          </button> */}
            </div>
          </div>

          {/*  TABLE SWITCHING */}
          <div className="flex-1 min-h-0 overflow-hidden">
            {["upi", "cash", "qr", "credit", "failed"].includes(activeTab) && (
              <div className="flex flex-col h-full">
                {/* TABLE */}
                <div className="mt-0">
                  <OrdersTable
                    type={activeTab === "failed" ? "failed" : activeTab}
                    data={paginatedData}
                    loading={
                      loading ||
                      transactionsReportLoading ||
                      orderDetailsLoading
                    }
                    onOrderClick={handleOrderClick}
                  />
                </div>

                {totalPages > 1 && (
                  <PaginationComponent
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onNextPage={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    onPrevPage={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    onPageClick={(page) => setCurrentPage(page)}
                  />
                )}
              </div>
            )}
            {activeTab === "settlements" && (
              <ProcessedSettlementsTable
                data={settlementInvoices}
                loading={loading}
              />
            )}
            {activeTab === "packky" && (
              <AssignToPackky data={filteredData("packky")} loading={loading} />
            )}
            {activeTab === "campaign" && (
              <div className="flex-1 min-h-0 overflow-hidden">
                <CampaigningCharges
                  campaigns={campaigns}
                  whatsappNumbers={whatsappNumbers}
                  loading={loading}
                />
              </div>
            )}
            {/* {activeTab === "refund" && (
          <RefundTable data={refunds} loading={loading} />
        )} */}
          </div>

          <WalletTransactionModal
            show={showWalletModal}
            onClose={() => setShowWalletModal(false)}
            data={walletTransactions}
            loading={loading}
            fromDate={walletFromDate}
            toDate={walletToDate}
            setFromDate={setWalletFromDate}
            setToDate={setWalletToDate}
            onFetch={handleWalletFetch}
          />

          {selectedOrder && (
            <OrderDetailsModal
              order={selectedOrder}
              onClose={() => setSelectedOrder(null)}
            />
          )}
        </div>
      </div>
    </>
  );
};
